<template>
  <div class="live-dashboard vh-100 d-flex flex-column">
    <b-row
      align-content="center"
      match-height
    >
      <b-col
        cols="12"
        md="3"
      >
        <counter-card
          title-text="Poliçe Adet"
          sub-title-text="YTD"
          sub-title-text2="MTD"
          :value-data="dashboardData.counters.ytdPoliceAdet | toNumber"
          :value-data2="dashboardData.counters.mtdPoliceAdet | toNumber"
          color-class="success"
          prefix-text=""
          suffix-text="Adet"
          prefix-text2=""
          suffix-text2="Adet"
          icon-name="ActivityIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <counter-card-2
          title-text="Komisyon"
          sub-title-text="YTD"
          sub-title-text2="MTD"
          :value-data="dashboardData.counters.ytdKomisyon.amount | toNumber"
          :value-data2="dashboardData.counters.mtdKomisyon.amount | toNumber"
          :value2-data="dashboardData.counters.ytdKomisyon.rates | toNumber"
          :value2-data2="dashboardData.counters.mtdKomisyon.rates | toNumber"
          color-class="secondary"
          prefix-text=""
          prefix2-text="%"
          suffix-text="₺"
          suffix2-text=""
          prefix-text2=""
          prefix2-text2="%"
          suffix-text2="₺"
          suffix2-text2=""
          icon-name="PercentIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <counter-card
          title-text="Net Prim"
          sub-title-text="YTD"
          sub-title-text2="MTD"
          :value-data="dashboardData.counters.ytdNetPrim | toNumber"
          :value-data2="dashboardData.counters.mtdNetPrim | toNumber"
          color-class="warning"
          prefix-text=""
          suffix-text="₺"
          prefix-text2=""
          suffix-text2="₺"
          icon-name="DollarSignIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <counter-card-2
          title-text="Yenileme Adet - Oran"
          sub-title-text="YTD"
          sub-title-text2="MTD"
          :value-data="dashboardData.counters.ytdRenewals.counts | toNumber"
          :value-data2="dashboardData.counters.mtdRenewals.counts | toNumber"
          :value2-data="dashboardData.counters.ytdRenewals.rates | toNumber"
          :value2-data2="dashboardData.counters.mtdRenewals.rates | toNumber"
          color-class="secondary"
          prefix-text=""
          prefix2-text="%"
          suffix-text="Adet"
          suffix2-text=""
          prefix-text2=""
          prefix2-text2="%"
          suffix-text2="Adet"
          suffix2-text2=""
          icon-name="PercentIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
    </b-row>
    <b-row
      align-content="center"
      match-height
    >
      <b-col
        cols="12"
        md="4"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Aylık Poliçe Adet"
            card-sub-title="YTD"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="monthlyInsurances"
          />
          <div
            v-if="loadings.monthlyInsurances"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <area-charts
              v-if="dashboardData.monthlyInsurances.series.length"
              :series-data="dashboardData.monthlyInsurances.series"
              :categories-data="dashboardData.monthlyInsurances.categories"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Oto Dışı Üretim"
            card-sub-title="YTD"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="ytdNonAutomotive"
          />
          <div
            v-if="loadings.ytdNonAutomotive"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <pie-charts
              v-if="dashboardData.ytdNonAutomotive.series.length"
              :series-data="dashboardData.ytdNonAutomotive.series"
              :labels-data="dashboardData.ytdNonAutomotive.labels"
              :colors-data="dashboardData.ytdNonAutomotive.colors"
            />
            <div class="d-flex align-items-center justify-content-center pb-1 mt-n2">
              <div class="text-center border-right mr-1 pr-1 width-100">
                <div class="font-small-2 text-primary">
                  Oto Üretim
                </div>
                <div class="font-weight-bolder">
                  %{{ dashboardData.ytdNonAutomotive.rates.automotive.rates }}
                </div>
                <div class="font-weight-bold font-small-1 text-muted">
                  {{ dashboardData.ytdNonAutomotive.rates.automotive.count | toNumber }} Adet
                </div>
              </div>
              <div class="text-center width-100">
                <div class="font-small-2 text-primary">
                  Oto Dışı Üretim
                </div>
                <div class="font-weight-bolder">
                  %{{ dashboardData.ytdNonAutomotive.rates.nonAutomotive.rates }}
                </div>
                <div class="font-weight-bold font-small-1 text-muted">
                  {{ dashboardData.ytdNonAutomotive.rates.nonAutomotive.count | toNumber }} Adet
                </div>
              </div>
            </div>
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="5"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Üretim Komisyon"
            card-sub-title="Sigorta Şirketi Bazlı"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="earnCompanies"
          />
          <div
            v-if="loadings.earnCompanies"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <stacked-vertical-bar-charts
              :series-data="dashboardData.earnCompanies.series"
              :categories-data="dashboardData.earnCompanies.categories"
              :colors-data="dashboardData.earnCompanies.colors"
            />
          </template>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        md="4"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Branş Bazlı Yenileme Oranı"
            card-sub-title="YTD"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="ytdRenewals"
          />
          <div
            v-if="loadings.ytdRenewals"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <stacked-bar-charts
              :series-data="dashboardData.ytdRenewals.series"
              :categories-data="dashboardData.ytdRenewals.categories"
              :colors-data="dashboardData.ytdRenewals.colors"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Marka Bazlı"
            card-sub-title="Marka Kasko Oranları"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="brandInsuranceRates"
          />
          <div
            v-if="loadings.brandInsuranceRates"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <column-charts
              v-if="dashboardData.brandInsuranceRates.series.length"
              :series-data="dashboardData.brandInsuranceRates.series"
              :categories-data="dashboardData.brandInsuranceRates.categories"
              :colors-data="dashboardData.brandInsuranceRates.colors"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="5"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Satış Performansı"
            card-sub-title="Aylık"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="salePerformance"
          />
          <div
            v-if="loadings.salePerformance"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <table-performance
              v-if="dashboardData.salePerformance.data.length"
              :data-list="dashboardData.salePerformance.data"
              :grand-totals="dashboardData.salePerformance.grandTotals"
            />
          </template>
        </b-card>
      </b-col>
    </b-row>
    <report-customizer
      :cache-info="cacheInfo"
      :refresh-data="refreshDashboard"
      :start-countdown="startCountdown"
    />
  </div>
</template>
<script>
import {
  BCard,
  BCol,
  BRow,
} from 'bootstrap-vue'
import ReportCustomizer from '@/views/Dashboard/Live/Components/ReportCustomizer.vue'
import CounterCard from '@/views/Dashboard/Live/Components/CounterCardDouble.vue'
import CounterCard2 from '@/views/Dashboard/Live/Components/CounterCard2Double.vue'
import PreLoading from '@/layouts/components/Loading.vue'
import ColumnCharts from '@/views/Dashboard/Live/InsurancesDashboard/ColumnCharts.vue'
import PieCharts from '@/views/Dashboard/Live/Charts/PieCharts.vue'
import AreaCharts from '@/views/Dashboard/Live/Charts/AreaCharts.vue'
import CardCustomHeader from '@/views/Dashboard/Live/Components/CardCustomHeader.vue'
import StackedVerticalBarCharts from '@/views/Dashboard/Live/Charts/StackedVerticalBarCharts.vue'
import StackedBarCharts from '@/views/Dashboard/Live/InsurancesDashboard/StackedBarCharts.vue'
import TablePerformance from '@/views/Dashboard/Live/InsurancesDashboard/TablePerformance.vue'

export default {
  name: 'InsuranceDashboard',
  components: {
    BCard,
    BRow,
    BCol,
    TablePerformance,
    ColumnCharts,
    PieCharts,
    StackedVerticalBarCharts,
    StackedBarCharts,
    CardCustomHeader,
    AreaCharts,
    PreLoading,
    CounterCard,
    CounterCard2,
    ReportCustomizer,
  },
  data() {
    return {
      intervalId: null,
    }
  },
  computed: {
    loadings() {
      return this.$store.getters['liveInsurancesDashboard/loadings']
    },
    dashboardData() {
      return this.$store.getters['liveInsurancesDashboard/dashboardData']
    },
    cacheInfo() {
      return this.$store.getters['liveInsurancesDashboard/cacheInfo']
    },
    configData() {
      return this.$store.getters['liveDashboardConfig/configData']
    },
  },
  mounted() {
    this.startCountdown()
  },
  created() {
    this.getDashboard()
  },
  methods: {
    startCountdown() {
      if (this.configData.refreshTime !== false) {
        this.intervalId = setInterval(() => {
          this.refreshDashboard()
        }, this.configData.refreshTime)
      }
    },
    getDashboard() {
      this.getData('counters')
      this.getData('monthlyInsurances')
      this.getData('ytdNonAutomotive')
      this.getData('earnCompanies')
      this.getData('ytdRenewals')
      this.getData('brandInsuranceRates')
      this.getData('salePerformance')
    },
    refreshDashboard() {
      this.$store.commit('liveInsurancesDashboard/RESET_DASHBOARD_DATA')
      this.refreshData('counters')
      this.refreshData('monthlyInsurances')
      this.refreshData('ytdNonAutomotive')
      this.refreshData('earnCompanies')
      this.refreshData('ytdRenewals')
      this.refreshData('brandInsuranceRates')
      this.refreshData('salePerformance')
    },
    getData(type) {
      this.$store.dispatch('liveInsurancesDashboard/getData', { type })
    },
    refreshData(type) {
      this.$store.dispatch('liveInsurancesDashboard/refreshData', { type })
    },
  },
}
</script>
<style scoped>
.card-small .card-body{
  padding: 10px !important;
}
.card-fixed{
  overflow: hidden;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
